import { Suspense, lazy, useCallback } from "react";
import type { EmojiPickerProps as EmojiPickerPropsRoot } from "./emojipicker/EmojiPicker";

const LazyEmojiPicker = lazy(() => import("./emojipicker/EmojiPicker"));

export type EmojiPickerProps = EmojiPickerPropsRoot;

export function EmojiPicker(props: EmojiPickerProps) {
  const targetRef = useCallback((_node: HTMLElement | null) => undefined, []);
  const fallbackTarget = props.renderTarget?.(targetRef) || null;

  if (!props.isOpen) {
    return <>{fallbackTarget}</>;
  }

  return (
    <Suspense fallback={fallbackTarget}>
      <LazyEmojiPicker {...props} />
    </Suspense>
  );
}
